import { connectedStore } from '../../store';
import insertBlockAction from '../actions/insert-block';

const insertBlock = (blockId, variationId, refElementId, position, blockModifier, options) => {
  const store = connectedStore.get();
  store.dispatch(
    insertBlockAction(blockId, variationId, refElementId, position, blockModifier, options)
  );
};

export default insertBlock;
